export default "__VITE_ASSET__UhsPOXxj__"